import { customInstance } from '../../lib/api-client';
import type { AttachmentPayload } from '../../api/model';

export const MAX_FILE_BYTES = 5 * 1024 * 1024;
export const MAX_FILES = 5;

export const ALLOWED_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'text/plain',
  'text/csv',
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/webp',
];

export const ACCEPT_ATTR = '.pdf,.doc,.docx,.txt,.csv,.png,.jpg,.jpeg,.gif,.webp';

export const isAllowedType = (type: string): boolean => ALLOWED_TYPES.includes(type);

export const formatFileSize = (bytes: number): string => {
  if (!bytes) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.min(sizes.length - 1, Math.floor(Math.log(bytes) / Math.log(k)));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
};

// Reads a File
export const fileToPayload = (file: File): Promise<AttachmentPayload> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () =>
      resolve({ fileName: file.name, contentType: file.type, dataBase64: String(reader.result) });
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });

export const downloadAttachment = async (
  attachmentId: number,
  fileName: string,
  admin = false,
): Promise<void> => {
  const base = admin ? '/admin/feedback/attachments' : '/feedback/attachments';
  const blob = await customInstance<Blob>({
    url: `${base}/${attachmentId}`,
    method: 'GET',
    responseType: 'blob',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
